import { createFileRoute } from '@tanstack/react-router';
import { Unauthenticated } from '../organisms/Unauthenticated';

export const Route = createFileRoute('/_unauthenticated')({
  component: () => (
    <main className="bg-background-primary h-full w-full flex">
      <Unauthenticated />
    </main>
  ),
});
